/*
Sohel 11/02/2022 2699761741 Added Event Tactic Groups
Sohel 11/03/2022 2699761741 Changed Tab name
Rohini 12/05/2022 2699761741  changed side nav format
Ashraf 12/05/2022 2699761741 Fixed header labels

*/
import React, {useState} from 'react';
import Tabs from './Tab';
import LandingPage from '../../../Pages/LandingPage';

const EventTriggerGroup = () => {
  const tabLabels = ['Event Triggers'];
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <LandingPage
        title={'Triggers'}
        showTabs={true}
        tabValue={value}
        handleTabChange={handleChange}
        allAntTabs={tabLabels}
      >
        <div className={`global-field-dash-board`}>
          <div>
            <div>
              <Tabs value={value} />
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};

export default EventTriggerGroup;
